<!-- Loader -->
<div *ngIf="!isLoaded" class="flex h-[360px] w-full flex-col items-center justify-center gap-4">
  <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-gray-800"></div>
  <span class="text-sm font-medium text-gray-400 tracking-wide">
    Follower Growth
  </span>
</div>

<!-- Chart Content -->
<div *ngIf="isLoaded" class="w-full">

  <!-- Title (no extra card wrapper) -->
  <div class="mb-4 px-1 text-center">
    <h2 class="text-lg font-semibold tracking-tight text-gray-900">
      {{ title }}
    </h2>
  </div>

  <div class="grid grid-cols-12">

    <div class="col-span-12 flex min-h-[320px] items-center justify-center">

      <!-- TikTok Message -->
      <ng-container *ngIf="pages?.[0]?.platform?.toLowerCase().includes('tiktok'); else notTikTok">
        <div class="flex h-[320px] w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-6 text-center">
          <div>
            <p class="mb-1 text-sm font-semibold text-gray-500">
              TikTok analytics are not available yet.
            </p>
            <p class="text-xs text-gray-400">
              We're working on bringing you TikTok insights soon.
            </p>
          </div>
        </div>
      </ng-container>

      <!-- Non-TikTok Content -->
      <ng-template #notTikTok>
        <ng-container *ngIf="chartOptions?.series?.[0]?.data?.length; else noData">
          <div class="w-full">
            <apx-chart
              [series]="chartOptions?.series"
              [chart]="chartOptions?.chart"
              [xaxis]="chartOptions?.xaxis"
              [yaxis]="chartOptions?.yaxis"
              [dataLabels]="chartOptions?.dataLabels"
              [grid]="chartOptions?.grid"
              [stroke]="chartOptions?.stroke"
              [tooltip]="chartOptions?.tooltip"
              [legend]="chartOptions?.legend"
              [title]="chartOptions?.title"
              class="block h-full w-full"
            >
            </apx-chart>
          </div>
        </ng-container>

        <!-- No Data -->
        <ng-template #noData>
          <div class="flex h-[320px] w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-6 text-center">
            <div>
              <p class="mb-1 text-sm font-semibold text-gray-500">
                No data available
              </p>
              <p class="text-xs text-gray-400">
                Try adjusting filters or selecting a different period
              </p>
            </div>
          </div>
        </ng-template>
      </ng-template>

    </div>

  </div>
</div>